import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import FullTable from "components/FullTable"

class WeeklyStats extends Component {
	constructor(props) {
		super(props)
		this.state = {
			
		}
	}

	weeklyStats = () => {
		let columns = [
			{
				Header: "Year",
				accessor: "year",
			},
			{
				Header: "Week",
				accessor: "week",
			},
			{
				Header: "Gross Sales",
				accessor: "gross",
			},
			{
				Header: "Cancels",
				accessor: "cancels",
			},
			{
				Header: "Net Sales",
				accessor: "net",
			},
			{
				Header: "Closings",
				accessor: "closings",
			},
			{
				Header: "Realtor Involved %",
				accessor: "realtor_percent",
			},
			{
				Header: "Starts",
				accessor: "starts",
			},
			{
				Header: "Traffic",
				accessor: "traffic",
			},
		]
		let tableData = []
		_.forEach(this.props.payload.exec.weeklyStats, (r, year) => {
			_.forEach(r, (v, week) => {
				week = parseInt(week)
				let perc = Math.round((v.realtor_involved / v.grossNoBad) * 100)
				v.realtor_percent = `${perc}%`
				if (!isFinite(perc)) {
					v.realtor_percent = '0%'
				}
				delete v.grossNoBad
				tableData.push({
					...v,
					week,
					year
				})
			})
		})
		return (
			<div className="content">
				<FullTable classNames={'small'} data={tableData} columns={columns} name="weeklyStats" title="WeeklyStats" pageSize={20} leavePercents={true} />
			</div>
		)
	}


	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Weekly Stats" />
						{this.weeklyStats()}
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(WeeklyStats)
